<template>
  <BlockContainer class="table-item-expanded">
    <div class="row align-items-center">
      <div class="col object-header pl-5 pr-5">
        <div class="row">
          <div class="col object-name font-weight-normal" @click="setExpanded()">
            {{ details.name }}
          </div>

          <div class="col text-right object-actions">
            <RentalObjectActionMenu :rentalObjectId="rentalObjectId" :landlordId="landlordId" />
          </div>
        </div>

        <RentalObjectFeatures :rentalObjectId="rentalObjectId" />

        <div class="object-nav">
          <router-link
            :to="{
              name: 'rentalObject_details',
              params: {
                landlordId: this.landlordId,
                rentalObjectId,
              },
            }"
            class="btn btn-outline-dark btn-sm"
          >
            <i class="budicon-pencil-writing mr-1"></i>
            Rediger leieobjekt
          </router-link>
          <router-link
            :to="{
              name: 'rentalObject_ads',
              params: {
                landlordId: this.landlordId,
                rentalObjectId,
              },
            }"
            class="btn btn-outline-dark btn-sm"
          >
            <i class="budicon-announcement mr-1"></i>
            Annonser for leieobjektet
          </router-link>
          <router-link
            :to="{
              name: 'rentalObject_documents',
              params: {
                landlordId: this.landlordId,
                rentalObjectId,
              },
            }"
            class="btn btn-outline-dark btn-sm"
          >
            <i class="budicon-attachment mr-1"></i>
            Dokumenter
          </router-link>
          <router-link
            :to="'rentalObject/' + rentalObjectId + '/enrich?origin=rental_object_list'"
            class="btn btn-outline-dark btn-sm btn-enrich"
            >
            <i class="budicon-home-safe"></i>
            Innhent eiendomsdata
          </router-link>
        </div>
      </div>
    </div>

    <RentalObjectNotifications :rentalObjectId="rentalObjectId" />

    <div v-if="tenancies.length > 0" class="p-5">
      <Tenancies :tenancies="tenancies" :shouldShowRentalObject="false" :shouldShowSubButton="false" />
    </div>
    <div v-else-if="filter !== 'hidden'" class="px-5 py-1 pb-4 mt-3">
      <p class="noTenancyText">Ingen leieforhold registrert på dette leieobjektet</p>
      <EmptyStates
        class="mt-3"
        :hasLandlordNoRentalObject="false"
        :hasLandlordNoTenancy="true"
        :rentalObjectIdProp="rentalObjectId"
        compact
      />
    </div>
  </BlockContainer>
</template>

<script>
import { mapGetters } from 'vuex';
import BlockContainer from '@/components/BlockContainer';
import RentalObjectActionMenu from '@/components/single-object/RentalObjectActionMenu.vue';
import RentalObjectFeatures from '@/components/single-object/RentalObjectFeatures.vue';
import RentalObjectNotifications from '@/components/single-object/RentalObjectNotifications.vue';
import Checkbox from '@modules/husleie-framework/src/components/forms/inputs/checkbox/Checkbox.vue';
import Tenancies from '@/components/Tenancies.vue';
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';
import EmptyStates from '@/components/EmptyStates.vue';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';

export default {
  data() {
    return {
      env: process.env.NODE_ENV,
    };
  },
  components: {
    BlockContainer,
    RentalObjectActionMenu,
    RentalObjectFeatures,
    RentalObjectNotifications,
    EmptyStates,
    Tenancies,
    'hl-Select': Select,
    'hl-Checkbox': Checkbox,
    'hl-Button': Button,
  },

  props: {
    rentalObjectId: Number,
    landlordId: [Number, String],
    filter: String,
  },

  computed: {
    ...mapGetters(['getRentalObjectDetails', 'getRentalObjectStatusClass', 'getRentalObjectTenancies', 'isUserSudo']),

    tenancies() {
      if (this.filter === 'hidden') {
        return [];
      }
      const tenancies = this.getRentalObjectTenancies(this.rentalObjectId);

      if (!this.isUserSudo) {
        return tenancies.filter(tenancy => tenancy.status !== 'shadow');
      }
      return tenancies;
    },

    isShownMessageCheckBox() {
      return this.$store.state.isShownMessageCheckBox;
    },

    overviewUrl() {
      return `${this.details.uri.replace('rental_object', 'rentalObject')}/overview`;
    },

    imageAltText() {
      return `Besøk ${this.details.name ?? 'ditt leieobjekt.'}`;
    },

    details() {
      return (
        this.getRentalObjectDetails(this.rentalObjectId) || {
          name: 'unknown rental object',
        }
      );
    },
  },

  methods: {
    setExpanded() {
      this.$store.commit('setExpandedRentalObject', this.rentalObjectId);
      location.assign(`${location.origin}${this.overviewUrl}`);
    },
  },
};
</script>

<style scoped lang="scss">
.table-item {
  margin-bottom: 1.4rem !important;
  border-radius: $border-radius;
  border: 1px solid $gray-200;
}

.table-item-expanded {
  position: relative;
  margin-left: 0;
  margin-right: 0;

  .object-header {
    padding-top: 2em;
    padding-bottom: 1rem;
  }

  .object-name {
    font-size: 1.6rem;
  }
}

.object-name:hover {
  cursor: pointer;
}

.noTenancyText {
  font-size: 1rem;
}

.object-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

a.btn-enrich {
  color: var(--color-green);
  background-color: var(--color-white);
  border: 1px solid var(--color-green);
  padding: 0.25rem 0.5rem;
}

a.btn-enrich:hover {
  background-color: var(--color-green);
  color: var(--color-white);
}

</style>
